// LAP-550 — Header unifié des cards (icône + titre + sous-titre + valeur + delta)
import React from 'react'
import { Box, Stack } from '@mui/material'
import { invTheme } from './theme'
import Delta from './Delta'

export default function CardHeader({
  icon, // string (path/png/svg) OR React node
  title,
  subtitle,
  value, // primary metric (e.g. "12 540 €")
  delta, // { value: number, unit: '%' | '€', invert?: boolean }
  actions, // node (right side, e.g. icon buttons)
}) {
  const renderIcon = () => {
    if (!icon) return null
    if (typeof icon === 'string') {
      return (
        <Box
          sx={{
            height: 32,
            width: 32,
            mr: 1.25,
            borderRadius: '8px',
            backgroundColor: 'rgba(255,255,255,0.06)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            flexShrink: 0,
          }}
        >
          <img
            src={icon}
            alt=""
            style={{ width: 20, height: 20, objectFit: 'contain' }}
          />
        </Box>
      )
    }
    return (
      <Box
        sx={{
          height: 32,
          width: 32,
          mr: 1.25,
          borderRadius: '8px',
          backgroundColor: 'rgba(255,255,255,0.06)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#cfe1ff',
          flexShrink: 0,
        }}
      >
        {icon}
      </Box>
    )
  }

  return (
    <Box display="flex" alignItems="flex-start" gap={1}>
      {renderIcon()}
      <Box sx={{ minWidth: 0, flexGrow: 1 }}>
        <Box sx={{ ...invTheme.title, lineHeight: 1.2 }}>{title}</Box>
        {subtitle ? (
          <Box sx={{ ...invTheme.subtitle, mt: 0.5 }}>{subtitle}</Box>
        ) : null}
      </Box>
      <Stack alignItems="flex-end" spacing={0.5} sx={{ ml: 'auto', flexShrink: 0 }}>
        {actions ? <Box>{actions}</Box> : null}
        {value !== undefined && value !== null ? (
          <Box sx={invTheme.value}>{value}</Box>
        ) : null}
        {delta !== undefined && delta !== null ? <Delta {...delta} /> : null}
      </Stack>
    </Box>
  )
}
